import { useCallback } from "react";
import { Link } from "react-router-dom";
import { useCartCount } from "../../context/CartContext";
import "./CartDrawer.css";

const currencyFormatter = new Intl.NumberFormat("fr-FR", {
  style: "currency",
  currency: "EUR",
});

export default function CartDrawer() {
  const { cartItems, isCartDrawerOpen, closeCartDrawer } = useCartCount();

  const total = cartItems.reduce(
    (sum, item) => sum + (item.price ?? 0) * (item.quantity ?? 1),
    0
  );

  const handleOverlayClick = useCallback(() => {
    closeCartDrawer();
  }, [closeCartDrawer]);

  if (!isCartDrawerOpen) return null;

  return (
    <div
      className={`cart-drawer-overlay ${isCartDrawerOpen ? "cart-drawer-open" : ""}`}
      onClick={handleOverlayClick}
      role="presentation"
    >
      <aside
        className="cart-drawer-panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label="Mini-panier"
      >
        <div className="cart-drawer-panel-bg" />
        <div className="cart-drawer-content">
          <div className="cart-drawer-header">
            <h3>Panier</h3>
            <button
              type="button"
              className="cart-drawer-close"
              onClick={closeCartDrawer}
              aria-label="Fermer le panier"
            >
              ×
            </button>
          </div>

          <div className="cart-drawer-items">
            {cartItems.length === 0 ? (
              <p className="cart-drawer-empty">Votre panier est vide</p>
            ) : (
              cartItems.map((item) => (
                <article key={item.firestoreId ?? item.id} className="cart-drawer-item">
                  <div className="cart-drawer-item-image">
                    {item.image && (
                      <img src={item.image} alt={item.name} />
                    )}
                  </div>
                  <div className="cart-drawer-item-info">
                    <strong>{item.name}</strong>
                    <span className="cart-drawer-item-qty">× {item.quantity ?? 1}</span>
                    <span className="cart-drawer-item-price">
                      {currencyFormatter.format((item.price ?? 0) * (item.quantity ?? 1))}
                    </span>
                  </div>
                </article>
              ))
            )}
          </div>

          {cartItems.length > 0 && (
            <div className="cart-drawer-footer">
              <div className="cart-drawer-total">
                <span>Total</span>
                <strong>{currencyFormatter.format(total)}</strong>
              </div>
              <Link
                to="/Panier"
                className="cart-drawer-cta"
                onClick={closeCartDrawer}
              >
                Voir le panier
              </Link>
            </div>
          )}
        </div>
      </aside>
    </div>
  );
}
